var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChromiumRenderArchitecture = function SvgChromiumRenderArchitecture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 754.4294608960859 854.7113024446331",
    width: 1508.8589217921717,
    height: 1709.4226048892663,
    filter: "invert(93%) hue-rotate(180deg)"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(281.46086005514644 400.3359024857399) rotate(0 84.65625 63.6015625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.96 -2.57 C40.1 4.59, 82.08 -0.27, 165.36 2.09 M1.15 -0.15 C66.1 2.03, 135.39 2.12, 167.47 1.23 M170.62 1.55 C169.1 41.33, 171.92 81.54, 165.56 130.44 M170.57 0.77 C170.19 45.55, 167.32 86.08, 169.64 128.6 M168.45 125.64 C128.06 129.66, 86.53 127.43, -2.51 125.54 M170.99 126.42 C107.15 128.17, 45.36 128.26, 0.91 127.21 M-0.64 124.89 C-4.97 88.11, -3.67 47.47, -1.72 0.3 M-0.33 127.65 C2.22 82.79, -1.44 41.62, 0.01 1.03",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.46086005514644 440.9374649857399) rotate(0 79.5 23)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 79.5,
    y: 32,
    fontFamily: "Virgil,Trebuchet MS,Arial",
    fontSize: "36px",
    fill: "#000000",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "Skia")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(10 601.8398405372449) rotate(0 84.65625 63.6015625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.7 2.42 C49.68 2.86, 89.7 2.72, 170.15 -0.76 M0.13 0.26 C50.14 -1.35, 95.32 0.31, 170.23 -0.11 M171.35 3.08 C167.22 39.71, 171.57 89.92, 166.9 124.67 M168.98 0.09 C167.97 45.66, 167.51 92.52, 170.71 126.38 M170.19 126.45 C114.3 125.31, 56.08 125.89, 0.16 130.97 M168.03 126.99 C132.39 124.04, 95.88 125.4, 0.74 126.88 M3.62 124.07 C-3.28 101.42, 0.44 77.26, 1.87 0.62 M-1.39 127.78 C-0.12 79.1, 1.19 29.34, -1.63 1.54",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(284.58558072045 118.95320430979825) rotate(0 84.65625 63.6015625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.58 1.63 C37.37 3.2, 81.6 0.86, 169.31 -1.09 M1.19 0.62 C41.38 2.33, 83.72 0.23, 167.33 -1.06 M172.11 0.21 C165.62 27.96, 169.77 67.65, 173.02 126.23 M170.52 1.49 C170.42 43.61, 170.35 91.32, 168.93 126.94 M169.83 130.29 C112.89 123.67, 59.87 129.27, -0.22 128.9 M170.85 125.36 C105.91 129.25, 47.76 127.72, -1.26 128.54 M0.19 125.61 C-1.04 89.28, -0.66 59.16, -1.64 1.59 M-0.38 128.46 C0.71 79.28, 1 29.62, 1.89 -1.71",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(289.58558072045 159.55476680979825) rotate(0 79.5 23)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 79.5,
    y: 32,
    fontFamily: "Virgil,Trebuchet MS,Arial",
    fontSize: "36px",
    fill: "#000000",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "Blink")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(282.3950021601563 597.9259466617999) rotate(0 84.65625 63.6015625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.06 -3.96 C49.37 3.64, 98.26 -1.15, 171.6 -0.31 M1.3 -1.84 C44.81 -2.11, 86.78 -2.79, 169.97 0.77 M169.23 -3.75 C172.88 40.84, 169.42 79.71, 171.84 128.75 M167.38 0.33 C172.67 43.42, 170.01 90.6, 168.88 126.42 M167.27 124.7 C119.63 128.64, 71.63 127.44, 3.36 125.64 M169.03 128.11 C114.83 129.41, 62.22 127.62, -0.32 126.05 M-2.42 125.49 C0.58 98.7, -0.36 63.43, -0.66 0.89 M0.11 127.21 C3.02 78.46, 2.3 29.48, -1.31 0.91",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(561.2100128841935 600.3149514415439) rotate(0 84.65625 63.6015625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.51 3.09 C56.26 -3.98, 115.92 1.61, 169.09 1.7 M1.54 -1.85 C59.54 -1.39, 124.34 -2.93, 168.05 1.34 M169.5 -1.6 C166.28 32.91, 166.66 73.62, 167.67 128.79 M168.94 1.26 C168.03 49.74, 168.32 97.74, 171.2 125.49 M168.88 125.93 C118.8 123.31, 73.43 126.5, -0.64 123.38 M167.74 125.35 C121.43 130.28, 74.37 131.21, 0.31 128.84 M1.16 123.65 C-0.23 96.4, -2.63 64.23, 3.08 1.11 M-1.84 127.39 C-0.43 99.4, 1.94 68.18, -0.35 0.25",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(566.2100128841935 640.9165139415439) rotate(0 79.5 23)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 79.5,
    y: 32,
    fontFamily: "Virgil,Trebuchet MS,Arial",
    fontSize: "36px",
    fill: "#000000",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "PDF")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(30.18839415516959 10) rotate(0 339.662109375 28.740234375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.37 0 M14.37 0 C167.55 2.2, 320.17 3.24, 664.95 0 M14.37 0 C185.72 -4.55, 356.57 -4.16, 664.95 0 M664.95 0 C670.86 0.36, 678.14 8.13, 679.32 14.37 M664.95 0 C678.6 -0.18, 678.53 5.37, 679.32 14.37 M679.32 14.37 C677.71 25.8, 676.24 28.52, 679.32 43.11 M679.32 14.37 C677.98 25.51, 677.91 35.49, 679.32 43.11 M679.32 43.11 C683.14 52.73, 674.01 59.85, 664.95 57.48 M679.32 43.11 C676.02 49.86, 673.73 57.79, 664.95 57.48 M664.95 57.48 C429.06 52.86, 192.05 52.58, 14.37 57.48 M664.95 57.48 C411.66 60, 157.58 58.78, 14.37 57.48 M14.37 57.48 C3.5 55.38, -2.26 49.52, 0 43.11 M14.37 57.48 C1.25 61.43, -0.42 56.63, 0 43.11 M0 43.11 C-1.42 35.83, 3.12 22.43, 0 14.37 M0 43.11 C-1.22 32.86, 0.9 19.67, 0 14.37 M0 14.37 C0.96 5.2, 8.64 2.2, 14.37 0 M0 14.37 C2.12 6.69, 2.8 -1.91, 14.37 0",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.48136290516959 30.031562494165883) rotate(0 272.5 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 16,
    fontFamily: "Inconsolata,Monaco,Consolas,Courier New,Courier,monospace",
    fontSize: "16px",
    fill: "#6991de",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "<div style=\"width: 50px; height: 50px; background: red\" />")), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(34.90091296660853 298.34863956227434) rotate(0 335.7636718749999 28.740234375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.37 0 M14.37 0 C153.81 -1.54, 295.13 -2.9, 657.16 0 M14.37 0 C213.77 -4.33, 411.62 -4.19, 657.16 0 M657.16 0 C666.3 -3.21, 670.01 3.63, 671.53 14.37 M657.16 0 C670.33 -3.02, 668.69 6.55, 671.53 14.37 M671.53 14.37 C674.47 19.7, 674.99 33.84, 671.53 43.11 M671.53 14.37 C670.01 21.79, 671.1 31.8, 671.53 43.11 M671.53 43.11 C674.04 55.45, 664.15 57.99, 657.16 57.48 M671.53 43.11 C667.93 50.63, 662.32 61.64, 657.16 57.48 M657.16 57.48 C449.05 63.93, 237.23 61.92, 14.37 57.48 M657.16 57.48 C497.5 54.1, 339 54.09, 14.37 57.48 M14.37 57.48 C5.38 58.07, -1.98 51.36, 0 43.11 M14.37 57.48 C6.82 61.17, -2.98 56.65, 0 43.11 M0 43.11 C1.95 35.25, -2.23 23.35, 0 14.37 M0 43.11 C0.37 35.02, -1.42 24.45, 0 14.37 M0 14.37 C-2.82 3.33, 8.29 1.1, 14.37 0 M0 14.37 C3.63 8.56, 8.47 3.08, 14.37 0",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63 318.264) rotate(0 300.5000000000001 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 16,
    fontFamily: "Inconsolata,Monaco,Consolas,Courier New,Courier,monospace",
    fontSize: "16px",
    fill: "#5c940d",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "canvas->drawRect(0, 0, 50, 50, SkPaint { .fill = SkColor::Red })")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.05145984183218 681.5168663839021) rotate(0 29.5 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 29.5,
    y: 18,
    fontFamily: "Virgil,Trebuchet MS,Arial",
    fontSize: "20px",
    fill: "#000000",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "(GPU)")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.48793696759685 624.5067439990938) rotate(0 63.5 23)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 32,
    fontFamily: "Virgil,Trebuchet MS,Arial",
    fontSize: "36px",
    fill: "#000000",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "Ganesh")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.1965142214849 624.3073960610153) rotate(0 62 23)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 32,
    fontFamily: "Virgil,Trebuchet MS,Arial",
    fontSize: "36px",
    fill: "#000000",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "Raster")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(339.6496758844778 679.8567225665823) rotate(0 28 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 18,
    fontFamily: "Virgil,Trebuchet MS,Arial",
    fontSize: "20px",
    fill: "#000000",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "(CPU)")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(275.68462026194084 787.5299528874801) rotate(0 92.50437803670434 27.15459250447782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.1 0.8 C40.97 1.41, 84.19 1.93, 188.82 0.04 M-1.23 -0.35 C53.19 3.92, 107.49 1.36, 185.26 -1.56 M186.04 1.44 C187.82 17.06, 187.72 24.81, 183.72 52.21 M186.73 -0.18 C185.86 13.52, 184.44 25.45, 184.34 55.19 M187.43 52.5 C112.93 59.19, 46.83 55.01, 0.96 54.72 M185.83 53.44 C110.87 54.6, 37.67 57.76, 0.55 55.89 M3.93 57.41 C-1.87 33.95, 2.7 9.15, -1.57 0.53 M-0.73 56.05 C2.76 38.64, 0.44 28.67, 0.72 1.55",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(287.2859920929345 802.2323583259159) rotate(0 82.5 12)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Inconsolata,Monaco,Consolas,Courier New,Courier,monospace",
    fontSize: "20px",
    fill: "#0b7285",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "for(int i = 0;")), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(10.161049841823115 790.4021174356775) rotate(0 92.50437803670434 27.15459250447782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.34 3.54 C38.33 0.4, 77.48 0.66, 181.8 -1.52 M-1.23 0.77 C49.6 2.83, 99.11 3.84, 183.76 1.68 M187.38 -2.87 C182.55 20.77, 185.29 45.45, 187.77 51.72 M183.09 1.81 C184.67 17.71, 186.09 35.57, 186.88 52.85 M181.84 51.23 C138.88 51.85, 89.31 52.81, 0.59 52.33 M183.71 56.03 C136.87 56.37, 85.44 58.12, 1.25 53.07 M2.2 56.16 C1.54 34.98, -1.77 16.28, -1.46 3.5 M1.6 55.65 C1.11 38.08, -1.36 18.94, 1.79 -1.84",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.409450408779094 804.171877000044) rotate(0 82.5 12)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Inconsolata,Monaco,Consolas,Courier New,Courier,monospace",
    fontSize: "20px",
    fill: "#e67700",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "glDrawArrays()")), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(559.1483163388116 788.0273744985758) rotate(0 92.50437803670434 27.15459250447782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.37 -2.87 C70.67 -0.21, 146.54 3.01, 187.77 -2.59 M-1.92 1.81 C58.37 2.38, 117.63 3.26, 186.88 -1.45 M181.84 -3.08 C187.87 14.18, 187.86 29.69, 185.6 52.33 M183.71 1.72 C186.7 13.58, 184.62 29.82, 186.26 53.07 M187.21 56.16 C126.69 56.14, 63.42 55.04, -1.46 57.8 M186.61 55.65 C126.4 58.89, 63.37 57.53, 1.79 52.47 M-3.69 57.3 C-1.6 43.62, 3.38 22.08, -1.12 3.58 M1.13 54.62 C-1.19 34.93, 0.79 19.18, 0.98 -0.77",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567.4294608960859 802.9140529165796) rotate(0 88.5 12)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Inconsolata,Monaco,Consolas,Courier New,Courier,monospace",
    fontSize: "20px",
    fill: "#c92a2a",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "M0,0 L50,0 L50")), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(644.5711148448913 731.0758978812854) rotate(0 -0.47895577332133143 26.090906606669137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.32 1.8 C-0.41 14.96, 4.1 40.35, -0.94 49.07 M0.35 -1.3 C1.41 19.58, 1.37 36.74, 0.01 53.48",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(644.5711148448913 731.0758978812854) rotate(0 -0.47895577332133143 26.090906606669137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.78 51.76 L-9.37 42.59 L5.21 38.14 L1.41 50.97",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.73 54.83 C-3.15 46.09, -2 46.56, -7.08 37.19 M0.27 52.51 C-1.41 48.79, -3.76 42.37, -6.37 40.5 M-4.31 41.9 C-1.16 41.86, 5.14 39.62, 5.41 39.37 M-4.76 38.85 C-3.33 40.67, 1.03 39.17, 7.22 40.01 M5.47 37.72 C6.06 45.4, 4.12 48.02, -0.4 51.69 M7.36 40.21 C4.64 45.8, 2.8 50.62, -0.11 53.58 M0.01 53.48 C0.01 53.48, 0.01 53.48, 0.01 53.48 M0.01 53.48 C0.01 53.48, 0.01 53.48, 0.01 53.48",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.92270045859027 730.0914060143003) rotate(0 0.92469208968771 27.441287967206335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.16 3.12 C-2.77 13.37, 2.12 30.55, 3.33 52.35 M1.91 0.02 C-0.01 21.43, -0.24 39.3, 2.18 54.86",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.92270045859027 730.0914060143003) rotate(0 0.92469208968771 27.441287967206335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.73 53.74 L-1.92 43.42 L10.21 43.77 L4.44 55.48",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.32 57.21 C-1.8 49.24, -0.9 46.53, -4.9 40.2 M3.61 54.88 C-0.7 51.11, -4.43 44.52, -5.76 42.08 M-5.18 40 C-2.08 39.25, 5.93 41.87, 8.03 43.14 M-5.91 41.31 C-1.45 40.67, 3.09 42.28, 7 41.78 M6.12 42.02 C8.01 43.17, 6.64 51.39, 0.83 53.56 M7.48 40.85 C7.05 46.31, 4.61 50.95, 1.53 54.24 M2.18 54.86 C2.18 54.86, 2.18 54.86, 2.18 54.86 M2.18 54.86 C2.18 54.86, 2.18 54.86, 2.18 54.86",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.7830712387956 68.60037079296615) rotate(0 -0.31788983992908015 24.29495000846663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05 1.87 C0.69 13.45, -2.52 22.17, -2.69 50.22 M-0.74 -1.63 C1.78 10.92, -1.1 20.59, -0.3 47.22",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.7830712387956 68.60037079296615) rotate(0 -0.31788983992908015 24.29495000846663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.11 51.07 L-4.42 35.46 L7.71 31.9 L-1.96 44.4",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24 48.63 C-1.16 46.85, -4.89 42.93, -8.71 34.48 M-0.85 46 C-0.54 44.73, -4.05 41.35, -6.91 32.24 M-4.38 33.52 C-3.14 33.73, 0.94 31.38, 5.1 32.9 M-6.13 33.27 C-1.57 33.03, 3.86 32.99, 7.12 34.84 M3.9 31.79 C3.59 38, 4.08 43.96, -2.24 47.6 M7.42 34.02 C5.07 37.97, 4.32 40.95, -1.39 46.74 M-0.3 47.22 C-0.3 47.22, -0.3 47.22, -0.3 47.22 M-0.3 47.22 C-0.3 47.22, -0.3 47.22, -0.3 47.22",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.80835387827597 247.36943185047835) rotate(0 -0.3036015204015712 25.762404778646726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.66 0.89 C3.54 13.23, -3.71 32.95, 0.24 50.64 M-1.31 0.91 C-1.16 17.43, -1.47 34.16, -0.25 47.84",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.80835387827597 247.36943185047835) rotate(0 -0.3036015204015712 25.762404778646726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17 46.03 L-9.09 36.32 L7.81 31.42 L0.71 48.25",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.75 48.51 C0.12 40.9, -7.77 38.96, -7.34 36.17 M-1.23 48.52 C-3.8 43.81, -6.55 39.14, -7.71 34.07 M-9.08 34.46 C-5.09 32.07, -1.59 33.49, 7.43 36.15 M-7.49 33.61 C-4.08 34.02, 1.14 33.34, 4.53 34.4 M7.43 32.03 C6.36 40.5, 2.36 41.04, 1.53 45.69 M6.25 34.95 C2.96 37.43, 1.44 39.89, -1.69 49.2 M-0.25 47.84 C-0.25 47.84, -0.25 47.84, -0.25 47.84 M-0.25 47.84 C-0.25 47.84, -0.25 47.84, -0.25 47.84",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.17335079971645 358.73377625126784) rotate(0 0.10553548647567368 18.848285684538382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.43 -1.27 C-2.45 9.07, 0.68 23.03, 0.8 34.09 M-1.57 -1.85 C0.68 10.73, 2.01 22.4, 1.75 39.55",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.17335079971645 358.73377625126784) rotate(0 0.10553548647567368 18.848285684538382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.34 40.14 L-6.74 24.7 L9.68 29.08 L-0.84 42.99",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42 38.59 C-1.76 34.34, -1.57 32.89, -5.24 23.16 M0.57 38.16 C-0.08 35.84, -1.23 32.71, -4.53 27.26 M-4.03 23.78 C-1.2 25.57, 0.25 24.07, 9.87 26.58 M-5.93 26.15 C-2.2 27.1, 2.24 25.96, 7.7 26.04 M7.05 28.22 C3.94 27.93, 5.28 32.9, 2.34 37.76 M9.35 25.89 C5.26 31.94, 2.09 35.19, 1.48 39.65 M1.75 39.55 C1.75 39.55, 1.75 39.55, 1.75 39.55 M1.75 39.55 C1.75 39.55, 1.75 39.55, 1.75 39.55",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.37001432981765 726.1290716617999) rotate(0 -0.6405748893529335 30.09894212358688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03 1.99 C2.08 17.47, -2.91 39.51, -2.43 55.03 M-1.57 1.27 C1.03 20.07, 0.71 41.63, -0.17 58.93",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.37001432981765 726.1290716617999) rotate(0 -0.6405748893529335 30.09894212358688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.74 61.01 L-9.07 45.62 L9.41 43.85 L-4 61.98",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.61 60.43 C-0.34 53.32, -5.72 51.24, -7.09 42.64 M-1.34 59.88 C-2.37 52.75, -4.49 47.74, -5.39 45.57 M-4.41 45.7 C0.07 43.27, 3.32 47.9, 6.93 47.43 M-6.48 44.2 C-1.04 46.67, 4.87 44.96, 5.97 46.77 M6.04 45.52 C6.7 51.33, -0.07 52.78, 0.66 60.08 M5.75 46.12 C4.97 49.53, 2.33 54.41, -0.36 60.05 M-0.17 58.93 C-0.17 58.93, -0.17 58.93, -0.17 58.93 M-0.17 58.93 C-0.17 58.93, -0.17 58.93, -0.17 58.93",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.13233349450684 529.7387986565626) rotate(0 0.9358518883145734 34.673200391384285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1.2 C1.32 12.57, -1.41 32.53, 2.11 68.15 M0.23 1.47 C2.87 13.51, -0.19 27.28, -0.24 64.83",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.13233349450684 529.7387986565626) rotate(0 0.9358518883145734 34.673200391384285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.95 65.29 L-2.34 47.8 L10.16 54.62 L-0.51 61.84",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04 65.72 C-1.07 59.77, -4.72 60.33, -5.6 53.51 M-0.07 65.93 C-0.19 61.62, -3.99 58.49, -7.36 51.02 M-7.61 53.5 C0.37 50.41, 3.94 50.95, 6.36 53.61 M-5.92 51.58 C-1.68 51.33, 1.89 50.74, 6.87 51.9 M6.02 53.62 C5.39 57.95, 2.64 58.79, 2.71 64.32 M6.91 50.52 C3.82 55.65, 4.4 58.49, 0.29 64.98 M-0.24 64.83 C-0.24 64.83, -0.24 64.83, -0.24 64.83 M-0.24 64.83 C-0.24 64.83, -0.24 64.83, -0.24 64.83",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.6828937889213 528.5390274857399) rotate(0 140.09069543294333 32.75267668328331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.76 -0.4 C6.77 4.9, -11.29 26.41, 30.68 31.29 C72.65 36.17, 211.99 23.07, 253.58 28.89 C295.17 34.71, 275.63 60.23, 280.2 66.23 M-0.73 -3.09 C3.97 2.74, -12.96 30.27, 29.13 34.92 C71.23 39.57, 210.11 19.18, 251.83 24.79 C293.56 30.41, 273.91 61.92, 279.48 68.59",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.6828937889213 528.5390274857399) rotate(0 140.09069543294333 32.75267668328331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.57 67.31 L270.39 53.06 L282 51.64 L282.92 68.23",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.05 69.96 C277.29 64.53, 277.86 57.57, 272.02 53.59 M278.57 67.95 C277.98 65.97, 275.98 60.86, 272.25 55.65 M272.63 55.33 C278.76 56.5, 282.79 57.15, 283.51 55.86 M272.79 55.02 C274.94 54.37, 279.31 55.62, 284.3 54.63 M284.27 57.22 C285.97 58.5, 281.2 62.89, 279.15 66.19 M284.18 53.79 C284.17 58.02, 282.4 61.18, 280.54 67.66 M279.48 68.59 C279.48 68.59, 279.48 68.59, 279.48 68.59 M279.48 68.59 C279.48 68.59, 279.48 68.59, 279.48 68.59",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.7351172011854 528.5390274857399) rotate(0 -139.80114524211922 36.06929312141892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.01 0.11 C-4.33 5.07, 15.64 26.48, -26.43 31.07 C-68.49 35.66, -210.57 20.83, -252.39 27.65 C-294.2 34.48, -273.3 64.84, -277.3 72 M-3.44 -2.3 C-7.87 2.82, 14.6 28.03, -27.23 33.39 C-69.06 38.76, -212.69 23.05, -254.44 29.89 C-296.18 36.73, -274.82 67.65, -277.7 74.44",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.7351172011854 528.5390274857399) rotate(0 -139.80114524211922 36.06929312141892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-279.96 71.27 L-288.95 65.3 L-273.69 63.51 L-277.11 75.03",
    stroke: "none",
    strokeWidth: 0,
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277.58 77.27 C-282.72 70.37, -284.22 65.32, -286.2 60.91 M-277.15 74.2 C-280.98 71.19, -281.17 69.78, -287.05 60.47 M-284.69 62.25 C-279.97 59.54, -277.06 58.89, -272.59 57.84 M-286.91 62.84 C-281.46 60.52, -277.84 60.56, -274.49 60.21 M-273.44 59.57 C-273.88 63.72, -277.85 66.79, -278.57 76.78 M-273.73 60.39 C-275.41 64.55, -276.49 68.1, -276.27 74.45 M-277.7 74.44 C-277.7 74.44, -277.7 74.44, -277.7 74.44 M-277.7 74.44 C-277.7 74.44, -277.7 74.44, -277.7 74.44",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "none"
  })))));
};
export default SvgChromiumRenderArchitecture;